import React from "react";
import { Grid } from "@mui/material";
import CommentSkeleton from "./commentSkeleton";
import { CommentsSkeletonProps } from "models/propTypes/skeletonPropTypes";

const CommentsSkeleton: React.FC<CommentsSkeletonProps> = (props) => {
  const commentsCount = React.useMemo(() => [...Array(props.commentsCount ?? 3).keys()], [props.commentsCount]);
  return (
    <Grid container direction="column" gap={2}>
      {commentsCount.map((c) => (
        <CommentSkeleton />
      ))}
    </Grid>
  );
};

export default CommentsSkeleton;
